/* eslint-disable */
import React, { Component } from 'react'; 
import HTMLText from '../UiComponent/HTMLText';
import ReCAPTCHA from "react-google-recaptcha";
import RadioButton from '../UiComponent/RadioButton';
import Button from '../UiComponent/Button';
import InputField from '../UiComponent/InputField'
import RaceCheckBoxSelect from './RaceCheckBoxSelect'
import * as util from '../js/util.js';
import  './FormPage.scss'

 

class IndividualPersonalInfo extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			fMsg:this.props.wording,
			parent:this.props.parent,
			selectedList:[],
			raceInfo:this.props.raceInfo == null? {} :this.props.raceInfo	
		};	
		this.onSubmitClicked = this.onSubmitClicked.bind(this);		
		this.recaptchaValue =(window.info && window.info.t != undefined && window.info.t != null && window.info.t != "") ? "y" : "";
		this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
    }
    

    componentWillReceiveProps(nextProps) {
		this.setState({fMsg:nextProps.wording,raceInfo:nextProps.raceInfo});
	} 
	
	componentDidMount() {             
	}

	componentWillUnmount() {
	}    
	onRecaptchaChange(value){
		this.recaptchaValue = value;
	}
	onSubmitClicked(){
		if ((this.state.chineseName == null || this.state.chineseName.length == 0)){
			this.props.showError(this.state.fMsg.emptyChineseNameZh+"<br/>"+this.state.fMsg.emptyChineseNameEn);	
			return;		
		}else if(!util.validateEngName(this.state.englishName)){
			this.props.showError(this.state.fMsg.incorrectEnglishNameZh+"<br/>"+this.state.fMsg.incorrectEnglishNameEn);	
			return;
		}
	
		if ((this.state.englishName == null || this.state.englishName.length == 0)){
			this.props.showError(this.state.fMsg.emptyEnglishNameZh+"<br/>"+this.state.fMsg.emptyEnglishNameEn);	
			return;		
		}else if(!util.validateEngName(this.state.englishName)){
			this.props.showError(this.state.fMsg.incorrectEnglishNameZh+"<br/>"+this.state.fMsg.incorrectEnglishNameEn);	
			return;
		}

		if ((this.state.email == null || this.state.email.length == 0)){
			this.props.showError(this.state.fMsg.emptyEmailZh+"<br/>"+this.state.fMsg.emptyEmailEn);
			return;
		}else if(!util.validateEmail(this.state.email)){
			this.props.showError(this.state.fMsg.incorrectEmailZh+"<br/>"+this.state.fMsg.incorrectEmailEn);
			return;
		}

		if ((this.state.reemail == null || this.state.reemail.length == 0)){
			this.props.showError(this.state.fMsg.emptyReemailZh+"<br/>"+this.state.fMsg.emptyReemailEn);
			return;
		}else if(this.state.reemail != this.state.email){
			this.props.showError(this.state.fMsg.emailNotMatchZh+"<br/>"+this.state.fMsg.emailNotMatchEn);
			return;
		}
		
		
		if (!util.validateDate(this.state.dobDay+ '-' + this.state.dobMonth + '-' + this.state.dobYear) ){
			this.props.showError(this.state.fMsg.incorrectDobZh+"<br/>"+this.state.fMsg.incorrectDobEn);
			return;			
		}
		if((this.state.mobile == null || this.state.mobile == 0)){
			this.props.showError(this.state.fMsg.emptyMobileZh+"<br/>"+this.state.fMsg.emptyMobileEn);
			return;
		}else if(!util.validateMobile(this.state.mobile)){
			this.props.showError(this.state.fMsg.incorrectMobileZh+"<br/>"+this.state.fMsg.incorrectMobileEn);
			return;
		}

		
		if (util.getAge(this.state.dobYear+ '-' + this.state.dobMonth + '-' + this.state.dobDay) < 18 ){
			if ((this.state.guardianName == null || this.state.guardianName.length == 0)){		
				this.props.showError(this.state.fMsg.emptyGuardianNameZh+"<br/>"+this.state.fMsg.emptyGuardianNameEn);		
				return;
			}
			
			if((this.state.guardianMobile == null || this.state.guardianName.guardianMobile == 0)){
				this.props.showError(this.state.fMsg.emptyGuardianMobileZh+"<br/>"+this.state.fMsg.emptyGuardianMobileEn);
				return;
			}else if(!util.validateMobile(this.state.guardianMobile)){
				this.props.showError(this.state.fMsg.incorrectGuardianMobileZh+"<br/>"+this.state.fMsg.incorrectGuardianMobileEn);
				return;
			}
		}
		
		if ((this.state.id == null || this.state.id.length == 0)){
			this.props.showError(this.state.fMsg.emptyIdZh+"<br/>"+this.state.fMsg.emptyIdEn);
			return;
		}else if (this.state.id.length != 4){
			this.props.showError(this.state.fMsg.incorrectIdZh+"<br/>"+this.state.fMsg.incorrectIdEn);
			return;
		}

		if ((this.state.gender == null || this.state.gender.length == 0)){
			this.props.showError(this.state.fMsg.emptyGenderZh+"<br/>"+this.state.fMsg.emptyGenderEn);
			return;
		}

		if ((this.state.selectedList == null || this.state.selectedList.length == 0)){
			this.props.showError(this.state.fMsg.emptyRaceZh+"<br/>"+this.state.fMsg.emptyRaceEn);
			return;
		}else{
			var appliedRaceLevel = ''
			if (this.state.selectedList && this.state.raceInfo.raceItem){
				var appliedRaceId = this.state.selectedList;
				for (var i=0; i<appliedRaceId.length; i++){
					for (var j=0; j<this.state.raceInfo.raceItem.length; j++){
						if (this.state.raceInfo.raceItem[j].id == appliedRaceId[i]){						
							if(appliedRaceLevel==''){
								appliedRaceLevel=this.state.raceInfo.raceItem[j].level;
							}else if(appliedRaceLevel != this.state.raceInfo.raceItem[j].level){
								this.props.showError(this.state.fMsg.raceDifferentLevelZh+"<br/>"+this.state.fMsg.raceDifferentLevelEn);
								return;
							}
						}
					}
				}
				
			};
		}


		if (this.state.raceInfo && this.state.raceInfo.optFieldDisplayLevel != null && this.state.raceInfo.optFieldOptionEn != null 
			&& this.state.raceInfo.optFieldOptionZh != null){
			var optFieldDisplayTypeArr = this.state.raceInfo.optFieldDisplayLevel && this.state.raceInfo.optFieldDisplayLevel.toUpperCase().split("|");		
			var displayOptField = false;
			const self = this;
			
			this.state.raceInfo.raceItem.forEach(function(item) {
				self.state.selectedList.forEach(function(race){
					if (race == item.id){
						if (optFieldDisplayTypeArr.includes(item.level.toUpperCase())){
							displayOptField = true;
						}
					}
				})
			});		
			if (displayOptField &&this.state.raceInfo.optFieldType.toUpperCase() == 'R'  ){
				if (this.state.optField == null || this.state.optField == ""){
					this.props.showError(this.state.fMsg.optFieldEn.replace("<desc>",this.state.raceInfo.optFieldEn)+"<br/>"+
					this.state.fMsg.optFieldZh.replace("<desc>",this.state.raceInfo.optFieldZh));	
					return;
				}
			}
		
		}


		if (!this.recaptchaValue || this.recaptchaValue==''){
			this.props.showError(this.state.fMsg.recaptchaZh+"<br/>"+this.state.fMsg.recaptchaEn);	
			return;
		}
		this.props.onSubmitClicked(this.state);
	}
	
	render() {		
		return (
            <React.Fragment>
				<tr >
					<td className="personal-info-title" colSpan='2'>
						<HTMLText text={this.state.fMsg.personalInfoTitleZh +"&nbsp;&nbsp;&nbsp;&nbsp;" + this.state.fMsg.personalInfoTitleEn}/>
					</td>
					
				</tr>		
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.chiNameZh +":<span class='ast'></span><br/>" + this.state.fMsg.chiNameEn +":<span class='ast'></span>"}/>
					</td>
					<td>	
						<InputField dataField='chineseName' maxLength='80' parent={this} type='text' value={this.state.chineseName}/>
					</td>
				</tr>
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.engNameZh +":<span class='ast'></span><br/>" + this.state.fMsg.engNameEn +":<span class='ast'></span>"}/>
					</td>
					<td>	
						<InputField dataField='englishName' maxLength='80' parent={this} type='text' value={this.state.englishName}/>
						
					</td>
				</tr>
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.dobZh +":<span class='ast'></span><br/>" + this.state.fMsg.dobEn +":<span class='ast'></span>"}/>
					</td>
					<td className='dob-td'>
						<InputField className='dob-input' dataField='dobYear' placeholder='YYYY' maxLength='4' parent={this} type='text' value={this.state.dobYear}/>
						<InputField className='dob-input' dataField='dobMonth' placeholder='MM' maxLength='2' parent={this} type='text' value={this.state.dobMonth}/>
						<InputField className='dob-input' dataField='dobDay' placeholder='DD' maxLength='2' parent={this} type='text' value={this.state.dobDay}/>
					</td>
				</tr>
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.idZh +":<span class='ast'></span><br/>" + this.state.fMsg.idEn +":<span class='ast'></span>"}/>
					</td>
					<td>	
						<InputField dataField='id' maxLength='4' parent={this} type='text' value={this.state.id}/>
					</td>
				</tr>

				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.genderZh +":<span class='ast'></span><br/>" + this.state.fMsg.genderEn +":<span class='ast'></span>"}/>
					</td>
					<td>
						<table className='gender-table'>
							<tbody>
								<tr>
									<td>
										<RadioButton className='gender' name='gender'
											value='M' parent={this} dataField='gender' curValue={this.state.gender} 
											text={this.state.fMsg.maleZh + "<br/>" + this.state.fMsg.maleEn}/>
									</td>
									<td>
										<RadioButton className='gender' name='gender'
											value='F' parent={this} dataField='gender' curValue={this.state.gender} 
											text={this.state.fMsg.femaleZh + "<br/>" + this.state.fMsg.femaleEn}/>          
										
									</td>
								</tr>
							</tbody>
						</table>
									
					</td>
				</tr>
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.mobileZh +":<span class='ast'></span><br/>" + this.state.fMsg.mobileEn +":<span class='ast'></span>"}/>
					</td>
					<td>	
						<InputField dataField='mobile' maxLength='20' parent={this} type='text' value={this.state.mobile}/>
					</td>
				</tr>

				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.emailZh +":<span class='ast'></span><br/>" + this.state.fMsg.emailEn +":<span class='ast'></span>"}/>
					</td>
					<td>	
						<InputField dataField='email' maxLength='80' parent={this} type='text' value={this.state.email}/>
					</td>
				</tr>
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.reemailZh +":<span class='ast'></span><br/>" + this.state.fMsg.reemailEn +":<span class='ast'></span>"}/>
					</td>
					<td>	
						<InputField dataField='reemail' maxLength='80' parent={this} type='text' value={this.state.reemail}/>
					</td>
				</tr>
				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.guardianNameZh +":<br/>" + this.state.fMsg.guardianNameEn +":"}/>
					</td>
					<td>	
						<InputField dataField='guardianName' maxLength='50' parent={this} type='text' value={this.state.guardianName}/>
					</td>
				</tr>

				<tr className="row">
					<td>
						<HTMLText text={this.state.fMsg.guardianMobileZh +":<br/>" + this.state.fMsg.guardianMobileEn +":"}/>
					</td>
					<td>	
						<InputField dataField='guardianMobile' maxLength='20' parent={this} type='text' value={this.state.guardianMobile}/>
					</td>
				</tr>	
				<RaceCheckBoxSelect type='INDIVIDUAL' maxRace={this.state.raceInfo.maxRace} selectedList={this.state.selectedList} raceInfo={this.state.raceInfo.raceItem} skaterYear={this.state.dobYear} wording={this.state.fMsg} parent={this} skaterGender={this.state.gender} eventInfo = {this.state.raceInfo} optField = {this.state.optField}/>
            	<tr>					
					<td className='tnc f3-font' colSpan='2'>	
						{this.state.raceInfo.hasFitness && (
							<HTMLText text={this.state.fMsg.tncZh+this.state.fMsg.fitnessTncZh +'<br/><br/>'}/>

						)}
						{!this.state.raceInfo.hasFitness && (<HTMLText text={this.state.fMsg.tncZh +'<br/><br/>'}/>		
						)}			
					</td>
				</tr>
				
				{!(window.info && window.info.t != undefined && window.info.t != null && window.info.t != "") && (
					<tr>					
					<td className='recaptchaTd' colSpan='2'>	
						<ReCAPTCHA className="g-recaptcha" sitekey="6Lc8lKIUAAAAAL7aQtbXYakp4xiea4tCX3Ox_WVm" onChange={this.onRecaptchaChange}/>
					</td>	 
				</tr>
				)}
				
				<tr>
					<td colSpan='2' className="btn-td">					
						<Button	className='submitButton defaultButton' onClickAction={()=> this.onSubmitClicked()} text={this.state.fMsg.submitZh+"<br/>"+this.state.fMsg.submitEn} />
					</td>	 
				</tr>
            </React.Fragment>
		);
	}
	//6LeAZKIUAAAAALVFAkVmSNcrxTtQabcMh9GiQkQY
}

export default IndividualPersonalInfo;